<!-- <template>
  <ul :class="['usc-sidenav--section', 'usc-sidenav--section_' + classSuffix, {'usc-sidenav--section_collapsed': collapsed}]">
    <li v-if="route">
      <router-link v-if="route" :to="{name: route}"
        class="usc-sidenav--section-title usc-sidenav--section-title__linked">
        {{title}}
      </router-link>

    </li> 

    <li v-else class="usc-sidenav--section-title"
      @click="collapseSection" href="#" 
      :aria-expanded="collapsed ? 'false' : 'true'" :aria-controls="_uid">
      <a href="#">{{title}}</a>
      <span class="caret" aria-hidden="true">
        <v-icon>keyboard_arrow_up</v-icon>
      </span>
    </li>

    <ul :id="_uid" class="usc-sidenav--items" :hidden="hidden">
      <li role="listitem"><slot></slot></li>
    </ul>
  </ul>
</template> -->

<template>
  <ul
    :class="[
      'usc-sidenav--section',
      'usc-sidenav--section_' + classSuffix,
      { 'usc-sidenav--section_collapsed': collapsed }
    ]"
  >
    <!-- Section title -->
    <li v-if="route">
      <router-link
        :to="{ name: route }"
        class="usc-sidenav--section-title usc-sidenav--section-title__linked"
      >
        {{ title }}
      </router-link>
    </li>

    <li v-else>
      <button
        class="usc-sidenav--section-title"
        @click="collapseSection"
        :aria-expanded="(!collapsed).toString()"
        :aria-controls="_uid"
      >
        {{ title }}
        <span class="caret" aria-hidden="true">
          <v-icon>keyboard_arrow_up</v-icon>
        </span>
      </button>
    </li>

    <!-- Sub-navigation (ONLY if slot has content) -->
    <li v-if="$slots.default">
      <ul
        :id="_uid"
        class="usc-sidenav--items"
        :hidden="collapsed"
      >
        <slot></slot>
      </ul>
    </li>
  </ul>
</template>

<script>

export default {
  name: 'usc-sidenav-section',
  props: ['title', 'route', 'class-suffix'],
  data () {
    return {
      collapsed: true,
      hidden: true
    }
  },
  methods: {
    checkRoute () {
      const childRoutes = this.$children.map(c => c.route)
      if (childRoutes.indexOf(this.$route.name) >= 0) {
        this.collapsed = false
        this.hidden = false
      }
    },
    collapseSection (event) {
      event.preventDefault()
      const newState = !this.collapsed
      if (newState) {
        // Collapsed
        this.collapsed = newState
        // HACK: Wait for the transition to finish (events weren't working)
        setTimeout(() => {
          this.hidden = newState
        }, 400)
      } else {
        this.hidden = newState
        /* HACK: When the hidden state is removed, the item
        immediately becomes visible and doesn't give the transition time to apply
        so wait 10ms before uncollapsing after unhiding to make sure the transition
        applies after the element is unhidden */
        setTimeout(() => {
          this.collapsed = newState
        }, 10)
      }
      return false
    }
  },
  watch: {
    '$route' (to, from) {
      this.checkRoute()
    }
  },
  mounted () {
    this.checkRoute()
  }
}
</script>

<style lang="scss" scoped>
@import '~styles/vars';
@import '~styles/mixins';

/* NOTE: The active marker on the right of the nav items at
* the top level title is a total hack, ripped from the SidenavItem component.
* It shouldn't be here. I'm sorry future dev.
*/
button.usc-sidenav--section-title {
    width: 100%;
    text-align: left;
}

.usc-sidenav--section {
  font-size: px2rem(15);
  &_collapsed {
    .usc-sidenav--section-title {
      // opacity: .5 !important;
      color: #fff !important;
      > .caret {
        transform: rotate(180deg);
        .icon {
          color: #fff !important;
        }
      }
    }
    .usc-sidenav--items {
      max-height: 0 !important;
    }
  }
  &.usc-sidenav--section_next_steps .usc-sidenav--section-title::after {
    background-color: $cNextSteps;
  }
  &.usc-sidenav--section_resources .usc-sidenav--section-title::after {
    background-color: $cResources;
  }
  .usc-sidenav--section-title {
    display: block;
    text-decoration: none;
    cursor: pointer;
    color: #fff;
    text-transform: uppercase;
    margin: 10px 0;
    padding: 10px 0;
    position: relative;
    opacity: 1;
    transition: .4s color;
    > .caret {
      position: absolute;
      right: 20px;
      transition: .4s transform;
    }
    &.router-link-exact-active {
      color: #FFF !important;
      &::after {
        transform: translate(-6px, 0);
      }
    }

    // Here's that thing I was talking about...
    &::after {
      content: '';
      display: block;
      position: absolute;
      width: 6px;
      height: 100%;
      top: 0;
      right: -6px;
      border-top-left-radius: 3px;
      border-bottom-left-radius: 3px;
      transition: .3s transform;
    }
  }
  .usc-sidenav--items {
    max-height: 1000px;
    transition: max-height .4s ease-out;
    overflow: hidden;
    list-style: none;
    padding-left: 12px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Sidenav/SidenavSection.vue